import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import SvgIcon from '@components/SvgIcon'
import { SvgIconName } from '@components/SvgIcon/types'

const StyledSvgIcon = styled(SvgIcon)`
  ${({
    theme: {
      spacing: { spacing40 },
    },
  }) => css`
    min-width: ${spacing40};
  `}
`

const StyledPlaceholderWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing24 },
    },
  }) => css`
    display: flex;
    gap: ${spacing24};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  `}
`
const StyledTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: headingSmall },
        },
      },
      spacing: { spacing4 },
    },
  }) => css`
    ${headingSmall};
    margin-bottom: ${spacing4};
  `}
`

const StyledText = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2 },
        },
      },
    },
  }) => css`
    ${bodycopySmall2};
  `}
`

interface PlaceholderProps {
  iconName: SvgIconName
  title: string
  text: string
  children: React.ReactNode
}

const Placeholder: FunctionComponent<PlaceholderProps> = ({
  iconName,
  title,
  text,
  children,
}) => {
  return (
    <StyledPlaceholderWrapper>
      <StyledSvgIcon iconName={iconName} size={80} />
      <div>
        <StyledTitle>{title}</StyledTitle>
        <StyledText>{text}</StyledText>
      </div>
      {children}
    </StyledPlaceholderWrapper>
  )
}

export default Placeholder
